import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { useCheckRenewVisaHistoryPage } from "@/features/renew-visa/hook/useCheckRenewVisaHistoryPage";
import { AppRoutes } from "@/routes/config";
import { elevation } from "@/theme/variables";
import { getDynamicRoute } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

type TEmployeeApplicationBtnActionsProps = {
  saveDraft: () => Promise<void>;
  readonly?: boolean;
  isEditable: boolean;
  setIsEditable: (v: boolean) => void;
};

export const EmployeeApplicationBtnActions: FC<TEmployeeApplicationBtnActionsProps> = ({ saveDraft, readonly, isEditable, setIsEditable }) => {
  const { renewVisaDocumentId, documentStepId, employeeRenewVisaDocumentGroupId } = useParams();
  const { isHistoryPage } = useCheckRenewVisaHistoryPage();
  const navigate = useNavigate();

  return (
    <InnerBox bordered p={3} boxShadow={elevation.lv2}>
      <Stack direction="row" gap={2} justifyContent={"space-between"}>
        <Button
          variant="ghost"
          size="lg"
          onClick={() => {
            if (isHistoryPage) {
              navigate(getDynamicRoute(AppRoutes.renewVisaInfoHistoryDetail, { employeeRenewVisaDocumentGroupId }));
            } else {
              navigate(getDynamicRoute(AppRoutes.renewVisaPresent, { employeeRenewVisaDocumentGroupId }));
            }
          }}
        >
          戻る
        </Button>
        <Stack direction="row" gap={2} justifyContent={"center"}>
          {!readonly && isEditable && (
            <>
              <Button variant="outline" size="lg" onClick={saveDraft}>
                下書き保存する
              </Button>
              <Button type="submit" variant="primary" size="lg">
                保存
              </Button>
            </>
          )}

          {!readonly && !isEditable && (
            <>
              <Button variant="outline" size="lg" onClick={() => setIsEditable(true)}>
                再編集する
              </Button>
              <Button
                variant="primary"
                size="lg"
                component={Link}
                to={getDynamicRoute(AppRoutes.renewVisaPresentCompanyApplication, {
                  employeeRenewVisaDocumentGroupId,
                  renewVisaDocumentId,
                  documentStepId,
                })}
              >
                次へ
              </Button>
            </>
          )}

          {readonly && (
            <Button
              variant="primary"
              size="lg"
              component={Link}
              to={getDynamicRoute(AppRoutes.renewVisaInfoHistoryCompanyApplication, {
                employeeRenewVisaDocumentGroupId,
                renewVisaDocumentId,
                documentStepId,
              })}
            >
              次へ
            </Button>
          )}
        </Stack>
      </Stack>
    </InnerBox>
  );
};
